import { ProductsTable } from "@/components/products/ProductsTable";
import { PageHeader } from "@/components/shared/page-header";

export function ProductsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Products" />
      <ProductsTable />
    </div>
  );
}
